var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Radio as ChakraRadio, RadioGroup, Stack, } from '@chakra-ui/react';
import { useMemo } from 'react';
const Group = (_a) => {
    var { value, options, layout = 'vertical', children, disabled: groupDisabled } = _a, extraProps = __rest(_a, ["value", "options", "layout", "children", "disabled"]);
    const optionList = useMemo(() => {
        if (options && options[0] && (typeof options[0] === 'string' || typeof options[0] === 'number')) {
            return options.map((item) => ({
                label: item,
                value: item,
            }));
        }
        return options || [];
    }, [options]);
    const layoutStyle = layout === 'horizontal' ? { spacing: 4, direction: 'row' } : {};
    return (_jsx(RadioGroup, Object.assign({ value: value }, extraProps, { children: children || (_jsx(Stack, Object.assign({}, layoutStyle, { children: optionList.map((item) => {
                const { label, value, disabled = groupDisabled } = item;
                return (_jsx(ChakraRadio, Object.assign({ value: value, isDisabled: disabled }, { children: label }), value));
            }) }))) })));
};
export const Radio = ChakraRadio;
Radio.Group = Group;
export default Radio;
